import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);


const api = "https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev";

export default new Vuex.Store({
  state: {
    total: {},
    redirectTable: {
      items: [],
    },
    dashboardTable: {
      items: [],
    },
    randomTable: {
      items: [],
    },
    table: {
      total: 0,
      items: [],
    },
    loading: {
      header: false,
      table: false,
      timeline: false,
    },
    error: {
      header: null,
      table: null,
      timeline: null,
    },
    details: null,
    active: false,
    controlPanelActive: false,
    dashboardActive: false,
    randomActive: false,
    redirect: null,
    redirectActive: false,
    timeline: [],
    dialog: {
      create: false,
      createregistro: false,
      conclude: false,
    },
    default: {
      page: "1",
      rows: "10",
      sortBy: "",
      sortDesc: "",
      id: "",
      id_status: "-1",
      email_gerente: "",
    },
    params: {
      page: "1",
      rows: "10",
      sortBy: "",
      sortDesc: "",
      id: "",
      id_status: "-1",
      email_gerente: "",
    },
    redirectParams: {
      id: "",
      email: "",
      email_criador: "",
      atual: "",
      id_status: "",
      data_trat_redirect: "",
    },
    dashboardParams: {
      page: "1",
      rows: "1000",
      sortBy: "",
      sortDesc: "",
      id: "",
      id_status: "",
      email_gerente: "",
    },

    randomParams: {
      id: "",
      email: "",
      email_criador: "",
      atual: "",
      id_status: "",
    },

    randomDefault: {
      id: "",
      email: "",
      email_criador: "",
      atual: "1",
      id_status: "",
    },

    dashboardDefault: {
      page: "1",
      rows: "1000",
      sortBy: "",
      sortDesc: "",
      id: "",
      id_status: "",
      email_gerente: "",
    },
  },

  mutations: {
    setDefaultParams(state, payload) {
      state.params = { ...state.default, ...payload };
    },

    setDashboardParams(state, payload) {
      state.dashboardParams = { ...state.dashboardDefault, ...payload };
    },

    setRandomParams(state, payload) {
      state.randomParams = { ...state.randomDefault, ...payload };
    },

    setControlPanelActive(state, { controlPanelActive }) {
      state.controlPanelActive = controlPanelActive;
    },

    setDashboardActive(state, { dashboardActive }) {
      state.dashboardActive = dashboardActive;
    },

    setRandomActive(state, { randomActive }) {
      state.randomActive = randomActive;
    },

    setDashboardP(state, payload) {
      state.dashboardP = { ...state.dashboardP, ...payload };
    },

    setParams(state, payload) {
      state.params = { ...state.params, ...payload };
    },

    setTotal(state, { total, novos, atrasados, andamento, concluidos }) {
      state.total = { total, novos, atrasados, andamento, concluidos };
    },

    setTable(state, { total, items }) {
      state.table = { total, items };
    },

    setRedirectTable(state, items) {
      state.redirectTable.items = items;
    },

    setDashboardTable(state, items) {
      state.dashboardTable.items = items.items;
    },

    setRandomTable(state, items) {
      state.randomTable.items = items;
    },

    setItems(state, { items }) {
      state.items = { items };
    },

    setLoading(state, { loading }) {
      state.loading = { ...state.loading, ...loading };
    },

    setError(state, { error }) {
      state.error = { ...state.error, ...error };
    },

    setDetails(state, { details }) {
      state.details = details;
    },

    setRedirect(state, { redirect }) {
      state.redirect = redirect;
    },

    setActive(state, { active }) {
      state.active = active;
    },

    setRedirectActive(state, { redirectActive }) {
      state.redirectActive = redirectActive;
    },

    setTimeline(state, { timeline }) {
      state.timeline = timeline;
    },

    setDialog(state, { dialog }) {
      state.dialog = { ...state.dialog, ...dialog };
    },

    cleanDetails(state) {
      state.details = null;
      state.active = false;
      state.timeline = [];
    },

    cleanRedirect(state) {
      state.redirect = null;
      state.redirectActive = false;
    },
  },

  actions: {
    getData(context, payload) {
      context.dispatch("getHeaders");
      context.dispatch("getTable", payload);
    },

    getHeaders(context) {
      context.commit("setLoading", { loading: { header: true } });
      fetch(`${api}/entrevista/count`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: process.env.VUE_APP_AUTHORIZATION,
        },
        body: JSON.stringify(context.state.params),
      })
        .then((res) => res.json())
        .then((res) => {
          context.commit("setTotal", res);
        })
        .catch((error) => {
          context.commit("setError", { error: { header: error } });
        })
        .finally(() => {
          context.commit("setLoading", { loading: { header: false } });
        });
    },

    getTable(context) {
      context.commit("setLoading", { loading: { table: true } });
      fetch(`${api}/entrevista`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: process.env.VUE_APP_AUTHORIZATION,
        },
        body: JSON.stringify(context.state.params),
      })
        .then((res) => res.json())
        .then((res) => {
          context.commit("setTable", res);
        })
        .catch((error) => {
          context.commit("setError", { error: { table: error } });
        })
        .finally(() => {
          context.commit("setLoading", { loading: { table: false } });
        });
    },

    getRedirectTable(context) {
      context.commit("setLoading", { loading: { redirectTable: true } });
      fetch(`${api}/tratativa/redirect/list`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: process.env.VUE_APP_AUTHORIZATION,
        },
        body: JSON.stringify(context.state.redirectParams),
      })
        .then((res) => res.json())
        .then((res) => {
          context.commit("setRedirectTable", res);
        })
        .catch((error) => {
          context.commit("setError", { error: { redirectTable: error } });
        })
        .finally(() => {
          context.commit("setLoading", { loading: { redirectTable: false } });
        });
    },

    getDashboardTable(context) {
      context.commit("setLoading", { loading: { dashboardTable: true } });
      fetch(
        `https://fkxxb5k2vh.execute-api.sa-east-1.amazonaws.com/dev/entrevista/minidash`,
        {
          method: "POST",
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Authorization: process.env.VUE_APP_AUTHORIZATION,
          },
          body: JSON.stringify(context.state.dashboardParams),
        },
      )
        .then((res) => res.json())
        .then((res) => {
          context.commit("setDashboardTable", res);
        })
        .catch((error) => {
          context.commit("setError", { error: { dashboardTable: error } });
        })
        .finally(() => {
          context.commit("setLoading", { loading: { dashboardTable: false } });
        });
    },

    getRandomTable(context) {
      context.commit("setLoading", { loading: { randomTable: true } });
      fetch(`${api}/tratativa/redirect/list`, {
        method: "POST",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: process.env.VUE_APP_AUTHORIZATION,
        },
        body: JSON.stringify(context.state.randomParams),
      })
        .then((res) => res.json())
        .then((res) => {
          context.commit("setRandomTable", res);
        })
        .catch((error) => {
          context.commit("setError", { error: { randomTable: error } });
        })
        .finally(() => {
          context.commit("setLoading", { loading: { randomTable: false } });
        });
    },

    getTimeline(context) {
      // console.log('ATIVOU')
      // console.log("context", context)
      context.commit("setLoading", { loading: { timeline: true } });
      fetch(`${api}/timeline/${context.state.details.id}`, {
        method: "GET",
        headers: {
          "Content-type": "application/json",
          Accept: "application/json",
          Authorization: process.env.VUE_APP_AUTHORIZATION,
        },
      })
        .then((res) => res.json())
        .then((res) => {
          context.commit("setTimeline", { timeline: res });
        })
        .catch((error) => {
          context.commit("setError", { error: { timeline: error } });
        })
        .finally(() => {
          context.commit("setLoading", { loading: { timeline: false } });
        });
    },
  },
});
